import {
  Button,
  Card,
  CardContent,
  Grid,
  Snackbar,
  Typography,
  withStyles,
} from "@material-ui/core";
import axios from "axios";
import { Field, Form, Formik } from "formik";
import qs from "qs";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import * as Yup from "yup";
import Alert from "../../../../ui/alert";
import { Textfield } from "../../../../ui/form_fields";
import { NavbarLoggedOut } from "../../../../ui/navbar";

const initialValues = {
  password: "",
  password_confirmation: "",
  reset_password_token: "",
};

const RoundedButton = withStyles({
  root: {
    borderRadius: "100px",
  },
})(Button);

const CenteredCardContent = withStyles({
  root: {
    textAlign: "center",
  },
})(CardContent);

const validationSchema = Yup.object({
  password: Yup.string().required("Insira sua nova senha"),
  password_confirmation: Yup.string()
    .required("Confirme sua nova senha")
    .test({
      name: "passwordComparison",
      message: "As senhas devem ser iguais",
      test: (value, { parent }) => !value || value === parent.password,
    }),
});

const renderSuccess = (
  <CenteredCardContent>
    <Typography variant="h6" className="mb-15">
      Senha alterada com sucesso.
    </Typography>

    <RoundedButton
      href="/"
      size="large"
      variant="contained"
      color="primary"
      disableElevation
    >
      Voltar
    </RoundedButton>
  </CenteredCardContent>
);

const RecoveryPassword = () => {
  const { search } = useLocation();
  const history = useHistory();
  const formRef = useRef(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    try {
      await axios.patch("/auth/password", values);
      setSuccess(true);
    } catch ({ response }) {
      const { errors } = response.data;

      Object.keys(errors).map((key) =>
        formRef.current?.setFieldError(key, errors[key])
      );

      setError("Falha ao alterar senha.");
    }
  };

  const renderForm = (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      innerRef={formRef}
    >
      {({ isSubmitting, errors }) => (
        <Form>
          <CardContent>
            <Typography variant="h5" className="mb-30">
              Alterar senha
            </Typography>

            <Field name="reset_password_token" hidden />

            <Field
              name="password"
              type="password"
              label="Nova senha"
              className="mb-30"
              error={!!errors.password}
              helperText={errors.password}
              component={Textfield}
            />

            <Field
              name="password_confirmation"
              type="password"
              label="Confirme sua nova senha"
              className="mb-30"
              error={!!errors.password_confirmation}
              helperText={errors.password_confirmation}
              component={Textfield}
            />

            <RoundedButton
              type="submit"
              size="large"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              disableElevation
              fullWidth
            >
              Alterar senha
            </RoundedButton>
          </CardContent>
        </Form>
      )}
    </Formik>
  );

  useEffect(() => {
    const { reset_password_token } = qs.parse(search, {
      ignoreQueryPrefix: true,
    });

    if (reset_password_token) {
      formRef.current?.setFieldValue(
        "reset_password_token",
        reset_password_token,
        false
      );
    } else {
      history.replace("/");
    }
  }, []);

  return (
    <>
      <NavbarLoggedOut />

      <Grid direction="column" alignItems="center" className="mt-30" container>
        <Grid item>
          <Card variant="outlined">{success ? renderSuccess : renderForm}</Card>
        </Grid>
      </Grid>

      <Snackbar
        open={!!error}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setError(null)}
      >
        <Alert severity="error" message={error} />
      </Snackbar>
    </>
  );
};

export default RecoveryPassword;
